/**
 * orga-app-api - benutzerverwaltung-v1-oa3_1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface RolleBenutzerTotal { 
    benutzer_gesamt?: number;
    benutzer_erlaubt?: number;
    benutzer_ids?: Array<string>;
    info_benutzer_gesamt?: number;
    info_benutzer_erlaubt?: number;
    info_benutzer_ids?: Array<string>;
}

